import DeleteNoteDialog from "./DeleteNoteDialog";

export default DeleteNoteDialog;
